const ServicesCTA = () => {
  return (
    <section className="py-24 bg-gradient-to-br from-slate-900 to-slate-800">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            Ready to Get Started?
          </h2>
          <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto">
            Let's discuss how our services can help your business thrive in the digital age.
          </p>
          <button
            onClick={() => window.REACT_APP_NAVIGATE('/contact')}
            className="px-10 py-4 bg-gradient-to-r from-cyan-500 to-blue-600 text-white text-lg font-semibold rounded-lg hover:from-cyan-600 hover:to-blue-700 transition-all shadow-lg hover:shadow-cyan-500/50 whitespace-nowrap cursor-pointer"
          >
            Schedule a Consultation
          </button>
        </div>
      </div>
    </section>
  );
};

export default ServicesCTA;